import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Checkbox,
  Grid,
  IconButton,
  List,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";

import TopViewNav from "../CommonComponents/TopViewNav";
import { ExpenseListAction } from "../../actions/Expense";
import UseModal from "../Modal/Modal";
import moment from "moment/moment";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import PropTypes from "prop-types";
// import { alpha } from "@mui/material/styles";

// import ExpenseHeader from "./ExpenseListHeader";
import excelIcn from "../../img/excel.png";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { SummaryAction } from "../../actions/summary";
import { DataGrid } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { Stack } from "@mui/system";
import ExpenseExcel from "./ExpenseExcel";
import ExpenceAprrovedModal from "./ExpenceAprrovedModal";
import CircleIcon from "@mui/icons-material/Circle";
import ExpenseRejectedModal from "./ExpenseRejectedModal";
import { companyWiseEmp } from "../../actions/Companywiseclient";
import { exportExpenseExcelOnClick } from "./exportExpenseExcelOnClick";
import { expenseExportBlob } from "./expenseExportBlob";
import { useLocalStorage } from "../../Hooks/Index";

const ownerList = [
  {
    name: "hello",
    id: 2,
  },
  {
    name: "hello2",
    id: 1,
  },
];
const expensesDropdown = [
  {
    id: 1,
    type: true,
    name: "Meeting Expenses",
  },
  {
    id: 2,
    type: false,
    name: "Other Expenses",
  },
  {
    id: 3,
    // type: null,
    name: "All",
  },
];
const SatausFilter = [
  { id: 1, title: "APPROVED" },
  { id: 2, title: "REJECTED" },
  { id: 3, title: "PENDING" },
  { id: 4, title: "PARTIALLY_APPROVED" },
  { id: 5, title: "AMOUNT_DEVIATION" },
];

const topViewNavData = {
  title: "Expense List",
  backPathRoute: "/dashboard",
};

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
    expenseList,
    ApproverCount,
    isExpenseBulkApprove,
    localData,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell
          // padding="checkbox"
          style={{ color: "#fff", backgroundColor: "#32577e" }}
          label="desserts"
        >
          {/* Boolean(expenseList) &&
          Boolean(expenseList.length) &&
          expenseList[0].isMultiApproverEnabled */}
          {isExpenseBulkApprove ? (
            <Checkbox
              //color="primary"
              sx={{ color: "#fff" }}
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected == ApproverCount}
              onChange={onSelectAllClick}
              inputProps={{
                "aria-label": "select all desserts",
              }}
            />
          ) : null}{" "}
          S.No
        </TableCell>
       
        <TableCell
          style={{ color: "#fff", backgroundColor: "#32577e" }}
          align="center"
        >
          Create Date
        </TableCell>
        <TableCell
          style={{ color: "#fff", backgroundColor: "#32577e" }}
          align="center"
        >
          Expense Date
        </TableCell>
        <TableCell
          style={{ color: "#fff", backgroundColor: "#32577e" }}
          align="center"
        >
          Emp. Name
        </TableCell>
        {Boolean(localData?.isDepartmentVisible) ? (
          <TableCell
            style={{ color: "#fff", backgroundColor: "#32577e" }}
            align="center"
          >
            {JSON.parse(localStorage.getItem("Templatedata")).find(
              (label) => label.actualName === "Department",
            )?.displayName || "Department"}
          </TableCell>
        ) : (
          ""
        )}

        {localData?.isSubDepartmentEnable ? (
          <TableCell
            style={{ color: "#fff", backgroundColor: "#32577e" }}
            align="center"
          >
            {JSON.parse(localStorage.getItem("Templatedata")).find(
              (label) => label.actualName === "SubDepartment",
            )?.displayName || "Sub-Department"}
          </TableCell>
        ) : (
          ""
        )}
        <TableCell
          style={{ color: "#fff", backgroundColor: "#32577e" }}
          align="center"
        >
          {JSON.parse(localStorage.getItem("data")).hrmsCompanyId == 14
            ? "Party Details"
            : "Meeting Details"}
        </TableCell>
        <TableCell
          style={{ color: "#fff", backgroundColor: "#32577e" }}
          align="center"
        >
          Type
        </TableCell>
        <TableCell
          style={{ color: "#fff", backgroundColor: "#32577e" }}
          align="right"
        >
          Applied Amt. (₹)
        </TableCell>
        <TableCell
          style={{ color: "#fff", backgroundColor: "#32577e" }}
          align="right"
        >
          Approved Amt. (₹)
        </TableCell>
        <TableCell
          style={{ color: "#fff", backgroundColor: "#32577e" }}
          align="right"
        >
          Deviated Amt. (₹)
        </TableCell>

        {localData?.isOdMeterReadingRequiredOnOd ? (
          <TableCell
            style={{ color: "#fff", backgroundColor: "#32577e" }}
            align="center"
          >
            Odometer Distance (Kms)
          </TableCell>
        ) : (
          ""
        )}
        {localData?.isOdMeterReadingRequiredOnOd ? (
          <TableCell
            style={{ color: "#fff", backgroundColor: "#32577e" }}
            align="right"
          >
            Odometer Amt. (₹)
          </TableCell>
        ) : (
          ""
        )}
        <TableCell
          style={{ color: "#fff", backgroundColor: "#32577e" }}
          align="center"
        >
          {JSON.parse(localStorage.getItem("data")).hrmsCompanyId == 14
            ? "Descriptions"
            : "Remarks"}
        </TableCell>
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function EnhancedTableToolbar(props) {
  const { numSelected } = props;

  return (
    <Toolbar
    // sx={{
    //   pl: { sm: 2 },
    //   pr: { xs: 1, sm: 1 },
    //   ...(numSelected > 0 && {
    //     bgcolor: (theme) =>
    //       alpha(
    //         theme.palette.primary.main,
    //         theme.palette.action.activatedOpacity
    //       ),
    //   }),
    // }}
    >
      {numSelected > 0 ? (
        <Typography
          sx={{ flex: "1 1 100%" }}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {numSelected} Selected
        </Typography>
      ) : (
        <Typography
          sx={{ flex: "1 1 100%" }}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          {/* No Selected */}
        </Typography>
      )}

      {/* {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Filter list">
          <IconButton>
            <FilterListIcon />
          </IconButton>
        </Tooltip>
      )} */}
    </Toolbar>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const ExpenseList = ({ ExpencesData }) => {
  const [fromDate, setFromDate] = useState(
    moment(new Date()).format("YYYY-MM-DD"),
  );
  const [selectedSite] = useLocalStorage("selectedSite", null);
  const localData = JSON.parse(localStorage.getItem("data")) || {};
  const [pageNo, setPageNo] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalElements, setTotalElements] = useState(0);
  const [expenseStatusCount, setExpenseStatusCount] = useState({
    expenseApproved: 0,
    partiallyApproved: 0,
    pendingExpense: 0,
    rejectedExpense: 0,
    totalNoOfEmp: 0,
  });
  const [toDate, setToDate] = useState(moment(new Date()).format("YYYY-MM-DD"));
  const [expenseList, setExpenseList] = useState();
  const [expenseListExcel, setExpenseListExcel] = useState([]);
  const [isExcelDataLoading, setIsExcelDataLoading] = useState(false);
  const [noOfUniqueEmployees, setNoOfUniqueEmployees] = useState(0);
  const [meetingExpenseType, setMeetingExpenseType] = useState();
  const [expenseTypeId, setExpenseTypeId] = useState();
  const [expenseTypeData, setExpenseTypeData] = useState();
  const [showApproverBtn, setShowApproverBtn] = useState([]);

  const [useridFilter, setUseridFilter] = useState();
  const [userList, setUserList] = useState();
  const [selected, setSelected] = React.useState([]);
  const [selectedDepartment, setSelectedDepartment] = React.useState(null);
  const [selectedSubDepartment, setSelectedSubDepartment] =
    React.useState(null);
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("calories");
  const [filtercommunicationId, setFiltercommunicationId] = useState([]);
  const [odDailyId, setOdDailyId] = useState();
  const navigate = useNavigate();
  const [TotalEmp, setTotalEmp] = useState();
  const [TotalApproved, setTotalApproved] = useState();
  const [TotalPendding, setTotalPendding] = useState();
  const [totalPartialApproved, setTotalPartialApproved] = useState();
  const [TotalReject, setTotalReject] = useState();
  const [statausType, setStatausType] = useState("");
  const [StatusId, setStatusId] = useState({});
  const [ApproverCount, setArroverCount] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [rejectModal, setRejectModal] = useState(false);
  const [approvedAmount, setApprovedAmount] = useState("");
  const [appliedAmount, setAppliedAmount] = useState("");
  const [odometerAmount, setOdometerAmount] = useState("");
  const [remark, setRemark] = useState("");
  const [statusAmountType, setStatusAmountType] = useState("");
  const [isMultiApproverEnabled, setIsMultiApproverEnabled] =
    React.useState(false);
  const [isExpenseBulkApprove, setIsExpenseBulkApprove] = React.useState(false);
  const [departmentList, setDepartmentList] = React.useState([]);
  const [subDepartmentList, setSubDepartmentList] = React.useState([]);

  useEffect(() => {
    if (selectedDepartment?.departmentId) {
      if (Boolean(departmentList?.length > 0)) {
        const finalArr = departmentList?.filter(
          (item) => selectedDepartment?.departmentId !== item?.departmentId,
        );
        console.log("final arara : ", finalArr);
        setSubDepartmentList([...finalArr]);
      }
    } else {
      setSubDepartmentList([]);
    }
    setSelectedSubDepartment(null);
  }, [departmentList, selectedDepartment]);
  const [singleEmployee, setSingleEmployee] = useState({});
  const [teamfiletdataemp, setTeamfiletdataemp] = useState([]);
  let ArrpvedArray = [];
  let PenndingArry = [];
  let RejectArry = [];
  console.log(statausType, "statausType");

  const fetchExpenseListExcel = async () => {
    setIsExcelDataLoading(true);
    let hrmsID = JSON.parse(localStorage.getItem("data")).hrmsUserId;
    let userId = JSON.parse(localStorage.getItem("data")).id;
    const fetchLocaldata = JSON.parse(localStorage.getItem("ExpencesData"));
    const expensePayload = {
      hrmsCompanyId: JSON.parse(localStorage.getItem("data")).hrmsCompanyId,
      hrmsUserId: hrmsID,
      userId: userId,
      // isApproved: null,
      hrmsExpenseTypeId: expenseTypeId,
      fromDate:
        fetchLocaldata !== null && fetchLocaldata.from !== null
          ? fetchLocaldata.from
          : fromDate,
      toDate:
        fetchLocaldata !== null && fetchLocaldata.to !== null
          ? fetchLocaldata.to
          : toDate,
      isOnlyMeeting: meetingExpenseType,
      filterUserId: useridFilter,
      communicationIds:
        fetchLocaldata !== null && fetchLocaldata.communicationIds !== null
          ? fetchLocaldata.communicationIds
          : filtercommunicationId
            ? filtercommunicationId
            : null,
      expenseStatus: statausType !== "" ? statausType : null,
      odDailyDistanceIds:
        fetchLocaldata !== null && fetchLocaldata.odDailyDistanceIds !== null
          ? [fetchLocaldata.odDailyDistanceIds]
          : odDailyId
            ? [odDailyId]
            : null,
      hrmsToken: JSON.parse(localStorage.getItem("data")).hrmsToken,
      departmentId: selectedDepartment && selectedDepartment.departmentId,
      pageNo: 0,
      pageSize: 0,
    };
    const res = await ExpenseListAction.fetchExpenseList(expensePayload);
    if (res !== null) {
      setExpenseListExcel(res.data.userExpenseDtoList);
      exportExpenseExcelOnClick(res?.data?.userExpenseDtoList || []);
    } else {
      setExpenseListExcel(res.data.userExpenseDtoList);
      exportExpenseExcelOnClick(res?.data?.userExpenseDtoList || []);
    }
    setIsExcelDataLoading(false);
  };

  const fetchExportExpenseExcel = async () => {
    setIsExcelDataLoading(true);
    let hrmsID = JSON.parse(localStorage.getItem("data")).hrmsUserId;
    let userId = JSON.parse(localStorage.getItem("data")).id;
    const fetchLocaldata = JSON.parse(localStorage.getItem("ExpencesData"));
    const expensePayload = {
      hrmsCompanyId: JSON.parse(localStorage.getItem("data")).hrmsCompanyId,
      hrmsUserId: hrmsID,
      userId: userId,
      // isApproved: null,
      hrmsExpenseTypeId: expenseTypeId,
      fromDate:
        fetchLocaldata !== null && fetchLocaldata.from !== null
          ? fetchLocaldata.from
          : fromDate,
      toDate:
        fetchLocaldata !== null && fetchLocaldata.to !== null
          ? fetchLocaldata.to
          : toDate,
      isOnlyMeeting: meetingExpenseType,
      filterUserId: useridFilter,
      communicationIds:
        fetchLocaldata !== null && fetchLocaldata.communicationIds !== null
          ? fetchLocaldata.communicationIds
          : filtercommunicationId
            ? filtercommunicationId
            : null,
      expenseStatus: statausType !== "" ? statausType : null,
      odDailyDistanceIds:
        fetchLocaldata !== null && fetchLocaldata.odDailyDistanceIds !== null
          ? [fetchLocaldata.odDailyDistanceIds]
          : odDailyId
            ? [odDailyId]
            : null,
      hrmsToken: JSON.parse(localStorage.getItem("data")).hrmsToken,
      departmentId: selectedDepartment && selectedDepartment.departmentId,
      isDepartmentVisible: localData?.isDepartmentVisible ? true : false,
      isSubDepartmentEnable: localData?.isSubDepartmentEnable ? true : false,
      subDepartmentId:
        selectedSubDepartment && selectedSubDepartment.departmentId,
      departmentDisplayName:
        JSON.parse(localStorage.getItem("Templatedata")).find(
          (label) => label.actualName === "Department",
        )?.displayName || "Department",
      subDepartmentDisplayName:
        JSON.parse(localStorage.getItem("Templatedata")).find(
          (label) => label.actualName === "SubDepartment",
        )?.displayName || "Sub-Department",
      pageNo: 0,
      pageSize: 0,
    };
    const res = await ExpenseListAction.exportExpenseExcel(expensePayload);
    if (res !== null) {
      expenseExportBlob(res);
    } else {
      console.error("No data to export.");
    }
    setIsExcelDataLoading(false);
  };

  const fetchExpenseList = async () => {
    let hrmsID = JSON.parse(localStorage.getItem("data")).hrmsUserId;
    let userId = JSON.parse(localStorage.getItem("data")).id;
    const fetchLocaldata = JSON.parse(localStorage.getItem("ExpencesData"));
    const expensePayload = {
      hrmsCompanyId: JSON.parse(localStorage.getItem("data")).hrmsCompanyId,
      hrmsUserId: hrmsID,
      userId: userId,
      // isApproved: null,
      hrmsExpenseTypeId: expenseTypeId,
      fromDate:
        fetchLocaldata !== null && fetchLocaldata.from !== null
          ? fetchLocaldata.from
          : fromDate,
      toDate:
        fetchLocaldata !== null && fetchLocaldata.to !== null
          ? fetchLocaldata.to
          : toDate,
      isOnlyMeeting: meetingExpenseType,
      filterUserId: useridFilter,
      communicationIds:
        fetchLocaldata !== null && fetchLocaldata.communicationIds !== null
          ? fetchLocaldata.communicationIds
          : filtercommunicationId
            ? filtercommunicationId
            : null,
      expenseStatus: statausType !== "" ? statausType : null,
      odDailyDistanceIds:
        fetchLocaldata !== null && fetchLocaldata.odDailyDistanceIds !== null
          ? [fetchLocaldata.odDailyDistanceIds]
          : odDailyId
            ? [odDailyId]
            : null,
      hrmsToken: JSON.parse(localStorage.getItem("data")).hrmsToken,
      departmentId: selectedDepartment && selectedDepartment.departmentId,
      isDepartmentVisible: localData?.isDepartmentVisible ? true : false,
      isSubDepartmentEnable: localData?.isSubDepartmentEnable ? true : false,
      subDepartmentId:
        selectedSubDepartment && selectedSubDepartment.departmentId,
      pageNo: pageNo,
      pageSize: pageSize,
    };
    const res = await ExpenseListAction.fetchExpenseList(expensePayload);
    if (res !== null) {
      // setExpenseList(res.data);
      setExpenseList(res.data.userExpenseDtoList);
      setTotalElements(res.data.totalElements);
      setExpenseStatusCount(
        res.data.expenseStatusCountResponse || expenseStatusCount,
      );
      const unique = [
        ...new Set(
          (res.data?.userExpenseDtoList || []).map((item) => item.userId),
        ),
      ];
      setNoOfUniqueEmployees(unique.length);
      (res.data?.userExpenseDtoList || []).map((val) => {
        const approvedCount = [val].filter(
          (arr) => arr.expenseStatus == "APPROVED",
        );

        if (approvedCount.length > 0) {
          ArrpvedArray.push(approvedCount);
        }
        setTotalApproved(ArrpvedArray.length);
      });
      (res.data?.userExpenseDtoList || []).map((val) => {
        const RejectArryCount = [val].filter(
          (arr) => arr.expenseStatus == "REJECTED",
        );

        if (RejectArryCount.length > 0) {
          RejectArry.push(RejectArryCount);
        }
        setTotalReject(RejectArry.length);
      });
      (res.data?.userExpenseDtoList || []).map((val) => {
        const PenndingArryCount = [val].filter(
          (arr) => arr.expenseStatus == "PENDING",
        );

        if (PenndingArryCount.length > 0) {
          PenndingArry.push(PenndingArryCount);
        }
        setTotalPendding(PenndingArry.length);
      });
      setTotalPartialApproved(
        (res.data?.userExpenseDtoList || []).filter(
          (val) => val.expenseStatus === "PARTIALLY_APPROVED",
        ).length,
      );
    } else {
      setExpenseList([]);
    }
  };
  const fetchExpenseType = async () => {
    const res = await ExpenseListAction.fetchExpenseType();
    if (res !== null) {
      setExpenseTypeData(res.data);
      // setOwnerList([{ userId: 0, name: "ALL", empCode: "all" }, ...res.data]);
    } else {
      //   setExpenseList([]);
    }
  };
  const showApprovebtn = async () => {
    let userId = JSON.parse(localStorage.getItem("data")).id;
    const data = {
      approverId: userId,
    };
    const res = await ExpenseListAction.ShowApprover(data);
    if (res !== null) {
      setShowApproverBtn(res.data);
    } else {
    }
  };
  // const countApprovedata=()=>{
  //   expenseList &&  expenseList.map((val)=>{
  //     })
  // }
  // useEffect(()=>{
  //   countApprovedata()
  // },[])
  // const showFilteredData = async () => {
  //   let hrmsID = JSON.parse(localStorage.getItem("data")).hrmsUserId;
  //   const expensePayload = {
  //     hrmsUserId: hrmsID,
  //     isApproved: null,
  //     hrmsExpenseTypeId: expenseTypeId,
  //     fromDate: fromDate,
  //     toDate: toDate,
  //     isOnlyMeeting: meetingExpenseType,
  //     filterUserId: useridFilter,
  //     communicationId:
  //       filtercommunicationId !== null ? filtercommunicationId : null,
  //     // filterUserId: useridFilter !== undefined && useridFilter,
  //     //   isOnlyMeeting: ,
  //   };
  //   const res = await ExpenseListAction.fetchExpenseList(expensePayload);
  //   if (res !== null) {
  //     setExpenseList(res.data);
  //   } else {
  //     setExpenseList([]);
  //   }
  // };

  const getMeetingExpenseType = (value) => {
    if (value !== null) {
      setMeetingExpenseType(value.type);
    } else {
      setMeetingExpenseType();
    }
  };
  const getExpenseType = (value) => {
    if (value !== null) {
      setExpenseTypeId(value.id);
    } else {
      setExpenseTypeId();
    }
  };

  const userListGet = async () => {
    let hrmsID = JSON.parse(localStorage.getItem("data")).hrmsUserId;
    const expensePayload = {
      hrmsUserId: hrmsID,
      isApproved: true,
      userId: JSON.parse(localStorage.getItem("data")).id,
      hrmsCompanyId: JSON.parse(localStorage.getItem("data")).hrmsCompanyId,
    };
    const res = await ExpenseListAction.fetchExpenseList(expensePayload);
    if (res !== null) {
      setUserList(res.data);
    } else {
      setUserList([]);
    }
  };
  const getUserNameFilter = async (value) => {
    if (value !== null) {
      setUseridFilter(value.userId);
      // let hrmsID = JSON.parse(localStorage.getItem("data")).hrmsUserId;
      // const expensePayload = {
      //   hrmsUserId: hrmsID,
      //   isApproved: true,
      //   filterUserId: value.userId,
      //   fromDate: fromDate,
      //   toDate: toDate,
      // };
      // const res = await ExpenseListAction.fetchExpenseList(expensePayload);
      // if (res !== null) {
      //   setExpenseList(res.data);
      // } else {
      //   setExpenseList([]);
      //   userListGet();
      // }
    } else {
      setUseridFilter();
    }
  };
  // const clearFilter = () => {
  //   fetchExpenseList();
  // }

  // const onchangeUserId=(e)=>{
  //   // if(e !==null){
  //   //   setSingleEmployee(e)

  //   // }
  //   // else{
  //   //   setSingleEmployee("")
  //   // }
  //   getUserNameFilter()
  //     }
  const expenseExport = () => {
    // fetchExpenseListExcel();
    fetchExportExpenseExcel();
    // if (isExcelDataLoading) {
    //   return;
    // } else {
    //   document.getElementById("expenseClick").click();
    // }
  };

  const fetchUserList = async () => {
    let hrmsID = JSON.parse(localStorage.getItem("data")).hrmsUserId;
    const data = {
      hrmsUserId: hrmsID && hrmsID,
      userId: JSON.parse(localStorage.getItem("data")).id,
      siteId: selectedSite ? selectedSite?.id : null,
    };
    const res = await SummaryAction.FetchUserList(data);
    if (res !== null) {
      setTeamfiletdataemp([
        { userId: 0, name: "ALL", empCode: "all" },
        ...res.data,
      ]);
    } else {
      setTeamfiletdataemp([]);
    }
  };
  const equalsCheck = (a, b) => {
    return JSON.stringify(a) === JSON.stringify(b);
  };
  const ApproveHandler = async (type) => {
    setStatusAmountType(type);
    if (type == "APPROVED" && selected.length == 1) {
      setOpenModal(true);
      return false;
    }

    if (selected.length == 0) {
      alert("Please select any expense record");
      return false;
    }

    let alertBtn;
    if (
      type === "REJECTED" &&
      (Boolean(expenseList) && Boolean(expenseList.length)
        ? expenseList[0].isMultiApproverEnabled
        : false)
    ) {
      // alertBtn = window.confirm("Are you Sure want to Reject Expense!!");
      setRejectModal(true);
      // if (alertBtn === false) {
      //   return false;
      // }
      return false;
    }

    if (
      type === "REJECTED" &&
      (Boolean(expenseList) && Boolean(expenseList.length)
        ? expenseList[0].isMultiApproverEnabled
        : false)
    ) {
      alertBtn = window.confirm("Are you Sure want to Reject Expense!!");
      if (alertBtn === false) {
        return false;
      }
    }

    if (type === "APPROVED") {
      alertBtn = window.confirm("Are you Sure want to Approve Expense!!");
      if (alertBtn === false) {
        return false;
      }
    }

    const data = {
      updatedBy: JSON.parse(localStorage.getItem("data")).id,
      ids: selected,
      expenseUpdatedStatus: type,
      hrmsCompanyId: JSON.parse(localStorage.getItem("data")).hrmsCompanyId,
    };
    // if(alertBtn){
    ExpenseListAction.fetchExpensSataus(data).then((res) => {
      if (res !== null) {
        fetchExpenseList();
        // fetchExpenseListExcel();
        setSelected([]);
        alert(`${type} Successfully`);
        // navigate("/outdoorduties");
      } else {
        console.log("error");
      }
    });
    // }
  };

  const ApproveAmountHandler = async () => {
    let alertBtn;
    // if (appliedAmount < approvedAmount) {
    if (
      (localData?.isOdMeterReadingRequiredOnOd
        ? Math.max(+appliedAmount || 0, +odometerAmount || 0)
        : +appliedAmount || 0) < (+approvedAmount || 0)
    ) {
      alert(
        localData?.isOdMeterReadingRequiredOnOd
          ? "Approved amount cannot be greater than Applied or Odometer amount!"
          : "Approved amount cannot be greater than Applied amount!",
      );
      return false;
    } else if (statusAmountType === "APPROVED" && approvedAmount < 1) {
      alert("Approved amount cannot be 0 or empty");
      return false;
    }
    if (statusAmountType === "APPROVED") {
      alertBtn = window.confirm("Are you Sure want to Approve Expense!!");
      if (alertBtn === false) {
        return false;
      }
    }

    if (statusAmountType === "REJECTED" && remark.trim() === "") {
      return alert("Reamrk is required.");
    }

    if (statusAmountType === "REJECTED") {
      alertBtn = window.confirm("Are you Sure want to Reject Expense!!");
      if (alertBtn === false) {
        return false;
      }
    }

    const data = {
      updatedBy: JSON.parse(localStorage.getItem("data")).id,
      ids: selected,
      expenseUpdatedStatus: statusAmountType,
      approvedAmount: approvedAmount,
      hrmsCompanyId: JSON.parse(localStorage.getItem("data")).hrmsCompanyId,
      remarks: remark,
    };
    ExpenseListAction.fetchExpensSataus(data).then((res) => {
      if (res !== null) {
        fetchExpenseList();
        // fetchExpenseListExcel();
        setSelected([]);
        setOpenModal(false);
        setRejectModal(false);
        alert(`${statusAmountType} Successfully`);
      } else {
        console.log("error");
      }
    });
  };
  // const teamFilterData = () => {
  //   let userArraydata = [];
  //   setTeamfiletdataemp(userList);

  //   console.log(userArraydata, "userArraydata");
  //   const filterTeam = TeamfilterId?.employeeDtoList?.map((user) => {
  //     const userFilterData = userList?.filter(
  //       (val) => val.hrmsUserId == user.id
  //     );
  //     if (userFilterData.length > 0) {
  //       userArraydata.push(userFilterData[0]);
  //     }
  //     // else if(teamfiletdataemp.length == 0){
  //     //   setTeamfiletdataemp()
  //     // }
  //     setTeamfiletdataemp(userArraydata);
  //     setUserId(userArraydata);
  //   });
  // };
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = expenseList.filter((n) => n.isUpdatable == true);

      const ApprovedId = newSelected && newSelected.map((val) => val.id);
      if (newSelected.length === 1) {
        setApprovedAmount(
          newSelected[0].amount || newSelected[0].appliedAmount,
        );
        setAppliedAmount(newSelected[0].appliedAmount || newSelected[0].amount);
        setOdometerAmount(newSelected[0].odometerExpenseAmount || 0);
      }
      setArroverCount(ApprovedId && ApprovedId.length);
      setSelected(ApprovedId);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    // setApprovedAmount(name && name.amount);
    // setAppliedAmount(name && name.amount);
    if (name.id.length == 0) {
      alert("Unable to select this expense , it may have other Approver ");
    }

    const allnewSelected = expenseList.filter((n) => n.isUpdatable == true);
    setArroverCount(allnewSelected && allnewSelected.length);
    const selectedIndex = selected.indexOf(name.id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name.id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    if (newSelected.length === 1) {
      const expenseItem = expenseList.find(
        (expense) => expense.id === newSelected[0],
      );
      setApprovedAmount(expenseItem?.amount || expenseItem?.appliedAmount || 0);
      setAppliedAmount(expenseItem?.appliedAmount || expenseItem?.amount || 0);
      setOdometerAmount(expenseItem?.odometerExpenseAmount || 0);
    }

    setSelected(newSelected);
  };
  // useEffect(()=>{
  //   handleClick()
  // },[])
  const StatusHandler = (e) => {
    if (e !== null) {
      setStatausType(e.title);
    } else {
      setStatausType("");
    }
  };
  const FiltrData = () => {
    if (pageNo === 0) {
      fetchExpenseList();
    } else {
      setPageNo(0);
    }
    // fetchExpenseListExcel();
  };

  const autoselcteddata = () => {
    const data = JSON.parse(localStorage.getItem("ExpencesData"));
    if (JSON.parse(localStorage.getItem("ExpencesData"))) {
      setStatausType(data ? data.Status : null);
      // setFiltercommunicationId(
      //   data !== undefined ? data.communicationIds : null
      // );
      // setOdDailyId(data ? data.odDailyDistanceIds : null);
      setFromDate(
        moment(data !== null ? data.from : new Date()).format("YYYY-MM-DD"),
      );
      setToDate(
        moment(data !== null ? data.to : new Date()).format("YYYY-MM-DD"),
      );
      // localStorage.removeItem("ExpencesData");
    }
  };
  const isSelected = (id) => selected.indexOf(id) !== -1;

  const openExpenceApprovedBySingleId = () => {
    setOpenModal(true);
  };

  const fetchCompanyWiseUpdate = () => {
    companyWiseEmp
      .fetchCompnyWiseUpdate({
        companyId: JSON.parse(localStorage.getItem("data")).hrmsCompanyId,
      })
      .then((res) => {
        if (res !== null) {
          setIsMultiApproverEnabled(
            res.data?.find(
              (item) =>
                item.hrmsConfigurationName ===
                "COMPANY_WISE_MULTILEVEL_APPROVER",
            )?.isEnable || false,
          );
          setIsExpenseBulkApprove(
            res.data?.find(
              (item) => item.hrmsConfigurationName === "EXPENSE_BULK_APPROVE",
            )?.isEnable || false,
          );
        }
      })
      .catch((err) => {
        console.log(err.message);
        setIsMultiApproverEnabled(false);
        setIsExpenseBulkApprove(false);
      });
  };

  const fetchDepartmentList = async () => {
    const response = await companyWiseEmp.getDepartmentConfigurationByCompanyId(
      {
        hrmsCompanyId: JSON.parse(localStorage.getItem("data")).hrmsCompanyId,
        hrmsToken: JSON.parse(localStorage.getItem("data")).hrmsToken,
        siteId: selectedSite ? selectedSite?.id : null,
      },
    );
    if (response !== null && response.responseCode === 200) {
      setDepartmentList(response.data);
    } else {
      setDepartmentList([]);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPageNo(newPage);
  };

  const handleChangeRowsPerPage = (e) => {
    setPageSize(parseInt(e.target.value, 10));
    setPageNo(0);
  };

  useEffect(() => {
    fetchDepartmentList();
    userListGet();
    // fetchExpenseList();
    fetchExpenseType();
    showApprovebtn();
    fetchUserList();
    autoselcteddata();
    // localStorage.removeItem("ExpencesData");
    fetchCompanyWiseUpdate();
    // fetchExpenseListExcel();
  }, [selectedSite]);

  useEffect(() => {
    fetchExpenseList();
  }, [pageNo, pageSize, selectedSite]);

  // useEffect(() => {
  //   if(JSON.parse(localStorage.getItem("ExpencesData"))){
  //     FiltrData()
  //     return false
  //   }
  //   else{
  //    // autoselcteddata()
  //   }

  // }, [JSON.parse(localStorage.getItem("ExpencesData"))]);
  // useEffect(() => {
  //   //fetchExpenseList();
  //    autoselcteddata();
  // }, [
  //   useridFilter,
  //   expenseTypeId,
  //   fromDate,
  //   toDate,
  //   meetingExpenseType,
  //   filtercommunicationId,
  //   statausType,
  // ]);
  return (
    <main className="contents__root expense_list">
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <Box
            sx={{
              display: "flex",
              alignItems: "end",
              justifyContent: "space-between",
            }}
          >
            <TopViewNav
              topViewNavData={topViewNavData}
              statusBtn={selected.length > 0 ? true : false}
              ApproveHandler={ApproveHandler}
              //ViewEmpCount={true}
            />
            <div style={{ display: "none" }}>
              <ExpenseExcel
                //  expenseList={expenseList}
                expenseList={expenseListExcel}
              />
            </div>
          </Box>
        </Grid>
        <ExpenceAprrovedModal
          openModal={openModal}
          setOpenModal={setOpenModal}
          title="Single Select Approver"
          approvedAmount={approvedAmount}
          setApprovedAmount={setApprovedAmount}
          appliedAmount={appliedAmount}
          setAppliedAmount={appliedAmount}
          odometerAmount={odometerAmount}
          remark={remark}
          setRemark={setRemark}
          ApproveAmountHandler={ApproveAmountHandler}
          isMultiLevelApprover={
            Boolean(expenseList) && Boolean(expenseList.length)
              ? expenseList[0].isMultiApproverEnabled
              : false
          }
          localData={localData}
        />
        <ExpenseRejectedModal
          openModal={rejectModal}
          setOpenModal={setRejectModal}
          title="Single Select Reject"
          remark={remark}
          setRemark={setRemark}
          ApproveAmountHandler={ApproveAmountHandler}
          isMultiLevelApprover={
            Boolean(expenseList) && Boolean(expenseList.length)
              ? expenseList[0].isMultiApproverEnabled
              : false
          }
        />
        {/* <CustomButton name={"TotalEmp"} background={"green"} /> */}
      </Grid>
      <Box
        sx={{
          display: "flex",
          gap: 1,
          mt: 0.5,
          mb: 1,
          width: {
            xs: "100%",
            md: "90%",
            xl: "70%",
          },
          marginLeft: "auto",
        }}
      >
        <div
          className="field"
          style={{
            backgroundColor: "#2a3478",
            // padding:"0px 3px"
          }}
        >
          <span>TotalEmp </span>
          <span className="count">
            {" "}
            {/* {noOfUniqueEmployees ? noOfUniqueEmployees : 0} */}
            {expenseStatusCount.totalNoOfEmp}
          </span>
        </div>
        <div
          className="field"
          style={{
            backgroundColor: "green",
          }}
        >
          <span>Approved </span>
          <span className="count">
            {/* {TotalApproved || 0} */}
            {expenseStatusCount.expenseApproved}
          </span>
        </div>
        {isMultiApproverEnabled && (
          <div
            className="field"
            style={{
              backgroundColor: "#F7AA5E",
            }}
          >
            <span>Partially Approved </span>
            <span className="count">
              {/* {totalPartialApproved || 0} */}
              {expenseStatusCount.partiallyApproved}
            </span>
          </div>
        )}
        <div
          className="field"
          style={{
            backgroundColor: "#E57373",
          }}
        >
          <span>Rejected </span>
          <span className="count">
            {/* {TotalReject || 0} */}
            {expenseStatusCount.rejectedExpense}
          </span>
        </div>
        {/* <CustomButton name={"Reject"} background={"red"} /> */}
        {/* <CustomButton name={"Pending"} background={"#a9a92f"} /> */}

        <div
          className="field"
          style={{
            backgroundColor: "#A9A92F",
          }}
        >
          <span>Pending </span>
          <span className="count">
            {/* {TotalPendding || 0} */}
            {expenseStatusCount.pendingExpense}
          </span>
        </div>
      </Box>

      <Grid container spacing={1}>
        <Grid item xs={12} sx={{ marginTop: "0px" }}>
          <Box className="top_fields" display={"flex"} gap="3px">
            <div
              className="field_box calender"
              style={{ alignItems: "inherit" }}
            >
              <span>From</span>
              <TextField
                name="fromDate"
                type="date"
                size="small"
                variant="outlined"
                //inputProps={{ max: toDate }}
                value={fromDate}
                onChange={(e) => {
                  setFromDate(e.target.value);
                  localStorage.removeItem("ExpencesData");
                  setFiltercommunicationId();
                  setOdDailyId();
                }}
              />
            </div>
            <div
              className="field_box calender"
              style={{ alignItems: "inherit" }}
            >
              <span>To</span>
              <TextField
                name="toDate"
                type="date"
                size="small"
                variant="outlined"
                //inputProps={{ max: toDate }}
                value={toDate}
                onChange={(e) => {
                  setToDate(e.target.value);
                  localStorage.removeItem("ExpencesData");
                  setFiltercommunicationId();
                  setOdDailyId();
                }}
              />
            </div>
            {/* department start */}
            {Boolean(localData?.isDepartmentVisible) ? (
              <div className="field_box expense_page_field">
                <Autocomplete
                  size="small"
                  id="header"
                  className="select_box"
                  options={departmentList}
                  getOptionLabel={(option) => option.departmentName}
                  disablePortal={true}
                  fullWidth
                  onChange={(event, newValue) => {
                    localStorage.removeItem("ExpencesData");
                    setSelectedDepartment(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      margin="dense"
                      placeholder={`Select ${
                        JSON.parse(localStorage.getItem("Templatedata")).find(
                          (label) => label.actualName === "Department",
                        )?.displayName || "Department"
                      }`}
                    />
                  )}
                />
              </div>
            ) : (
              ""
            )}

            {/* department end */}

            {localData?.isSubDepartmentEnable ? (
              <div className="field_box expense_page_field">
                <Autocomplete
                  size="small"
                  id="header"
                  className="select_box"
                  options={subDepartmentList}
                  value={selectedSubDepartment || null}
                  getOptionLabel={(option) => option.departmentName}
                  disablePortal={true}
                  fullWidth
                  onChange={(event, newValue) => {
                    localStorage.removeItem("ExpencesData");
                    setSelectedSubDepartment(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      margin="dense"
                      placeholder={`Select ${
                        JSON.parse(localStorage.getItem("Templatedata")).find(
                          (label) => label.actualName === "SubDepartment",
                        )?.displayName || "Sub-Department"
                      }`}
                    />
                  )}
                />
              </div>
            ) : (
              ""
            )}
            <div className="field_box expense_page_field">
              <Autocomplete
                size="small"
                id="header"
                className="select_box"
                options={
                  (expenseTypeData &&
                    expenseTypeData.length > 0 &&
                    expenseTypeData) ||
                  []
                }
                getOptionLabel={(option) => option.hrmsExpenseName}
                disablePortal={true}
                fullWidth
                onChange={(event, newValue) => {
                  localStorage.removeItem("ExpencesData");
                  getExpenseType(newValue);
                  setOdDailyId();
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    margin="dense"
                    placeholder="Expense Type"
                  />
                )}
              />
            </div>
            <div className="field_box expense_page_field">
              <Autocomplete
                size="small"
                id="header"
                className="select_box"
                options={expensesDropdown || []}
                getOptionLabel={(option) => option.name}
                disablePortal={true}
                fullWidth
                onChange={(event, newValue) => {
                  localStorage.removeItem("ExpencesData");
                  getMeetingExpenseType(newValue);
                  setOdDailyId();
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    margin="dense"
                    placeholder="Meeting Expense"
                  />
                )}
              />
            </div>
            <div className="field_box expense_page_field">
              <Autocomplete
                size="small"
                id="header"
                className="select_box"
                // options={ teamfiletdataemp.length == 0 ? userList : teamfiletdataemp }
                options={teamfiletdataemp || []}
                getOptionLabel={({ name, empCode }) => {
                  return `${name} ${empCode}`;
                }}
                disablePortal={true}
                fullWidth
                onChange={(event, newValue) => {
                  localStorage.removeItem("ExpencesData");
                  getUserNameFilter(newValue);
                  setOdDailyId();
                }}
                renderOption={(props, option) => {
                  return (
                    <List
                      sx={{ opacity: option.userId == 0 ? 0.5 : 1 }}
                      {...props}
                      key={option.userId}
                    >
                      {`${option.name}(${option.empCode})`}
                    </List>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    margin="dense"
                    // placeholder="Select Client Owner"
                    placeholder="Select Employee Name"
                  />
                )}
              />
            </div>
            <div className="field_box expense_page_field">
              <Autocomplete
                size="small"
                id="header"
                className="select_box"
                options={
                  isMultiApproverEnabled
                    ? SatausFilter
                    : SatausFilter.filter(
                        (statFilter) =>
                          statFilter.title !== "PARTIALLY_APPROVED",
                      )
                }
                // getOptionLabel={(option) => option.title}
                getOptionLabel={(designation) =>
                  designation.title ? designation.title : statausType
                }
                getOptionSelected={(option, value) =>
                  option.title ===
                  (value != null && value.title != null ? value.title : "")
                }
                filterSelectedOptions
                disablePortal={true}
                fullWidth
                onChange={(event, newValue) => {
                  localStorage.removeItem("ExpencesData");
                  StatusHandler(newValue);
                  setOdDailyId();
                }}
                value={statausType}
                renderOption={(props, option) => {
                  return (
                    <List {...props} key={option.userId}>
                      {option.title}
                    </List>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    margin="dense"
                    placeholder="Status"
                  />
                )}
              />
            </div>
            {/* <div className="field_box">
              <div
                className="field_box_btn"
                onClick={showFilteredData}
                style={{
                  cursor: "pointer",
                }}
              >
                Go
              </div>
            </div> */}
            {/* <div className="field_box">
              <div
                className="field_box_btn"
                onClick={clearFilter}
                style={{
                  cursor: "pointer",
                  width: "90px",
                }}
              >
                Clear Filter
              </div>
            </div> */}
            {/* <Button variant="outlined" startIcon={<LaunchIcon />} className="field_box btn client"> */}
            {/* <div style={{ display: "none" }}>
              <ReactHTMLTableToExcel
                id="clientExport"
                className="exportBtn"
                table="FlowUpTable"
                filename="FollowUp"
                sheet="Client Details"
                buttonText="Export"
              />
            </div> */}

            <ReactHTMLTableToExcel
              id="expenseClick"
              className="expense"
              table="expenseListExcel"
              filename="Expense"
              sheet="tablexls"
              buttonText=""
            />

            <Tooltip
              title={
                isExcelDataLoading
                  ? "Data is Loading Please wait."
                  : "Export Excel"
              }
            >
              <div
                style={{
                  // width: "10%",
                  marginTop: "2px",
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "center",
                }}
                onClick={expenseExport}
              >
                <img
                  src={excelIcn}
                  style={{
                    objectFit: "contain",
                    height: "34px",
                    cursor: "pointer",
                  }}
                  alt=""
                />
              </div>
            </Tooltip>
            <div className="field_box btn">
              <div
                id="Reportsbtn"
                onClick={FiltrData}
                style={{
                  cursor: "pointer",
                }}
              >
                Go
              </div>
            </div>
          </Box>
        </Grid>
        <Grid item xs={12}>
          {/* <ExpenseHeader
            fromDate={fromDate}
            setFromDate={setFromDate}
            toDate={toDate}
            setToDate={setToDate}
            ownerList={ownerList}
            statusId={statusId}
            setStatusId={setStatusId}
            clientId={clientId}
            setClientId={setClientId}
            showFilteredData={showFilteredData}
            statusData={statusData}
            exportHandler={exportHandler}
          /> */}
          {/* <EnhancedTableToolbar numSelected={selected.length} /> */}

          <TableContainer
            component={Paper}
            sx={{
              // height: "calc(100vh - 217px)",
              maxHeight: "calc(100vh - 270px)",
              "&::-webkit-scrollbar": {
                width: "0px",
              },
            }}
          >
            <Table
              size="small"
              border
              stickyHeader
              aria-label="sticky table"
              sx={{
                minWidth: 1200,

                "& tbody td": {
                  border: "0.5px solid #d0d7de",
                },

                // First column
                "& th:first-of-type, & td:first-of-type": {
                  position: "sticky",
                  left: 0,
                  zIndex: 2,
                  // backgroundColor: "#fff",
                },

                "td:first-of-type": {
                  backgroundColor: "#fff",
                },

                // Header cells
                "& thead th": {
                  position: "sticky",
                  top: 0,
                  zIndex: 3,
                  backgroundColor: "rgb(32 80 130)",
                  border: "none",
                },

                // Top-left cell needs highest z-index
                "& thead th:first-of-type": {
                  left: 0,
                  zIndex: 4,
                },
              }}
            >
              {/* <TableHead>
                <TableRow
                  style={{
                    backgroundColor: "rgb(32 80 130)",
                    color: "#fff",
                  }}
                  key={1}
                >
                  <TableCell
                    style={{ color: "#fff", backgroundColor: "#32577e" }}
                    align="center"
                  >
                    <Checkbox
                      color="primary"
                      //indeterminate={numSelected > 0 && numSelected < rowCount}
                      // checked={rowCount > 0 && numSelected === rowCount}
                      onChange={handleSelectAllClick}
                      value={selected}
                      //  order={order}
                      //  orderBy={orderBy}
                      onSelectAllClick={handleSelectAllClick}
                      //  onRequestSort={handleRequestSort}
                      inputProps={{
                        "aria-label": "select all desserts",
                      }}
                    />
                    S.No
                  </TableCell>
                  <TableCell
                    style={{ color: "#fff", backgroundColor: "#32577e" }}
                    align="center"
                  >
                    Create Date
                  </TableCell>
                  <TableCell
                    style={{ color: "#fff", backgroundColor: "#32577e" }}
                    align="center"
                  >
                    Expense Date
                  </TableCell>
                  <TableCell
                    style={{ color: "#fff", backgroundColor: "#32577e" }}
                    align="center"
                  >
                    Emp. Name
                  </TableCell>
                  <TableCell
                    style={{ color: "#fff", backgroundColor: "#32577e" }}
                    align="center"
                  >
                    {JSON.parse(localStorage.getItem("data")).hrmsCompanyId ==
                    14
                      ? "Party Details"
                      : "Meeting Details"}
                  </TableCell>
                  <TableCell
                    style={{ color: "#fff", backgroundColor: "#32577e" }}
                    align="center"
                  >
                    Type
                  </TableCell>
                  <TableCell
                    style={{ color: "#fff", backgroundColor: "#32577e" }}
                    align="center"
                  >
                    Amount(₹)
                  </TableCell>
                  <TableCell
                    style={{ color: "#fff", backgroundColor: "#32577e" }}
                    align="center"
                  >
                    {JSON.parse(localStorage.getItem("data")).hrmsCompanyId ==
                    14
                      ? "Descriptions"
                      : "Remarks"}
                  </TableCell>
                </TableRow>
              </TableHead> */}
              <EnhancedTableHead
                numSelected={selected.length}
                // order={order}
                // orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={selected.length}
                expenseList={expenseList}
                ApproverCount={ApproverCount}
                isExpenseBulkApprove={isExpenseBulkApprove}
                localData={localData}
              />
              <TableBody>
                {expenseList &&
                  expenseList.length > 0 &&
                  expenseList.map((data, index) => {
                    const isItemSelected = isSelected(data.id);
                    const labelId = `enhanced-table-checkbox-${index}`;

                    return (
                      <TableRow
                        //hover
                        //  onClick={(event) => handleClick(event, data.isUpdatable ==true?data.id:[])}
                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={data.id}
                        selected={isItemSelected}
                        sx={{
                          background:
                            data.isAmountDeviation == true &&
                            data.expenseStatus == "APPROVED"
                              ? "#ADD8E6"
                              : data.expenseStatus == "APPROVED"
                                ? "rgb(50 164 114)!important "
                                : data.expenseStatus == "REJECTED"
                                  ? "#E57373 !important"
                                  : data.expenseStatus ===
                                        "PARTIALLY_APPROVED" &&
                                      Boolean(data.trailData?.length)
                                    ? "#F7AA5E !important"
                                    : "",
                        }}
                      >
                        <TableCell>
                          {data.expenseStatus == "REJECTED" ||
                          data.expenseStatus == "APPROVED" ||
                          (data.expenseStatus == "PENDING" &&
                            data.isUpdatable == false) ? null : (
                            <Checkbox
                              color="primary"
                              // sx={color:!data.isUpdatable}
                              onClick={(event) =>
                                handleClick(
                                  event,
                                  data.isUpdatable == true ? data : [],
                                )
                              }
                              disabled={!data.isUpdatable}
                              checked={isItemSelected}
                              inputProps={{
                                "aria-labelledby": labelId,
                              }}
                            />
                          )}

                          {data.communicationId !== null
                            ? `M  ${index + 1}`
                            : index + 1}
                        </TableCell>
                        {/* <TableCell align="center">
                          {data.communicationId !== null
                            ? `M  ${index + 1}`
                            : index + 1}
                        </TableCell> */}
                        <TableCell align="center">
                          {moment(data.createdAt).format("DD-MM-YYYY")}
                        </TableCell>
                        <TableCell align="center">
                          {moment(data.expenseDate).format("DD-MM-YYYY")}
                        </TableCell>
                        <TableCell align="center">
                          {data.userName !== null ? data.userName : "NA"}(
                          {data.userEmpCode !== null ? data.userEmpCode : "NA"})
                        </TableCell>
                        {Boolean(localData?.isDepartmentVisible) ? (
                          <TableCell align="center">
                            {data.departmentName !== null
                              ? data.departmentName
                              : "NA"}
                          </TableCell>
                        ) : (
                          ""
                        )}
                        {localData?.isSubDepartmentEnable ? (
                          <TableCell align="center">
                            {data.subDepartmentName !== null
                              ? data.subDepartmentName
                              : "NA"}
                          </TableCell>
                        ) : (
                          ""
                        )}
                        <TableCell align="center">
                          {data.clientName !== null ? data.clientName : "NA"}
                        </TableCell>
                        <TableCell align="center">
                          {data.hrmsExpenseTypeDto &&
                            data.hrmsExpenseTypeDto.hrmsExpenseName}
                        </TableCell>
                        <TableCell align="right">
                          {data.appliedAmount?.toFixed(2) || "NA"}
                        </TableCell>
                        <TableCell align="right">
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              gap: "10px",
                            }}
                          >                            
                            <UseModal
                              button={"icon"}
                              title={`Expense - (${data.appliedAmount})`}
                              width={"65%"}
                            >
                              <TableContainer component={Paper}>
                                <Table size="small" id="FlowUpTable">
                                  <TableHead>
                                    <TableRow
                                      style={{
                                        backgroundColor: "rgb(32 80 130)",
                                        color: "#fff",
                                      }}
                                      key={1}
                                    >
                                      <TableCell
                                        style={{ color: "#fff" }}
                                        align="center"
                                      >
                                        S.No
                                      </TableCell>
                                      <TableCell
                                        style={{ color: "#fff" }}
                                        align="center"
                                      >
                                        Create Date
                                      </TableCell>
                                      <TableCell
                                        style={{ color: "#fff" }}
                                        align="center"
                                      >
                                        Expense Date
                                      </TableCell>
                                      <TableCell
                                        style={{ color: "#fff" }}
                                        align="center"
                                      >
                                        Emp. Name
                                      </TableCell>
                                      {Boolean(
                                        localData?.isDepartmentVisible,
                                      ) ? (
                                        <TableCell
                                          style={{ color: "#fff" }}
                                          align="center"
                                        >
                                          {JSON.parse(
                                            localStorage.getItem(
                                              "Templatedata",
                                            ),
                                          ).find(
                                            (label) =>
                                              label.actualName === "Department",
                                          )?.displayName || "Department"}
                                        </TableCell>
                                      ) : (
                                        ""
                                      )}

                                      {localData?.isSubDepartmentEnable ? (
                                        <TableCell
                                          style={{ color: "#fff" }}
                                          align="center"
                                        >
                                          {JSON.parse(
                                            localStorage.getItem(
                                              "Templatedata",
                                            ),
                                          ).find(
                                            (label) =>
                                              label.actualName ===
                                              "SubDepartment",
                                          )?.displayName || "Sub-Department"}
                                        </TableCell>
                                      ) : (
                                        ""
                                      )}
                                      <TableCell
                                        style={{ color: "#fff" }}
                                        align="center"
                                      >
                                        Meeting Details
                                      </TableCell>
                                      <TableCell
                                        style={{ color: "#fff" }}
                                        align="center"
                                      >
                                        Type
                                      </TableCell>
                                      <TableCell
                                        style={{ color: "#fff" }}
                                        align="center"
                                      >
                                        Applied Amt(₹)
                                      </TableCell>
                                      <TableCell
                                        style={{ color: "#fff" }}
                                        align="center"
                                      >
                                        Approved Amt(₹)
                                      </TableCell>
                                      <TableCell
                                        style={{ color: "#fff" }}
                                        align="center"
                                      >
                                        Deviated Amt(₹)
                                      </TableCell>
                                      {localData?.isOdMeterReadingRequiredOnOd ? (
                                        <TableCell
                                          style={{ color: "#fff" }}
                                          align="center"
                                        >
                                          Odometer Distance(Kms)
                                        </TableCell>
                                      ) : (
                                        ""
                                      )}
                                      {localData?.isOdMeterReadingRequiredOnOd ? (
                                        <TableCell
                                          style={{ color: "#fff" }}
                                          align="center"
                                        >
                                          Odometer Amount(₹)
                                        </TableCell>
                                      ) : (
                                        ""
                                      )}
                                      <TableCell
                                        style={{ color: "#fff" }}
                                        align="center"
                                      >
                                        Remark
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    <TableRow>
                                      <TableCell align="center">
                                        {data.communicationId !== null
                                          ? `M 1`
                                          : 1}
                                      </TableCell>
                                      <TableCell align="center">
                                        {moment(data.createdAt).format(
                                          "DD-MM-YYYY",
                                        )}
                                      </TableCell>
                                      <TableCell align="center">
                                        {moment(data.expenseDate).format(
                                          "DD-MM-YYYY",
                                        )}
                                      </TableCell>
                                      <TableCell align="center">
                                        {data.userName !== null
                                          ? data.userName
                                          : "NA"}
                                        (
                                        {data.userEmpCode !== null
                                          ? data.userEmpCode
                                          : "NA"}
                                        )
                                      </TableCell>
                                      {Boolean(
                                        localData?.isDepartmentVisible,
                                      ) ? (
                                        <TableCell align="center">
                                          {" "}
                                          {data.departmentName !== null
                                            ? data.departmentName
                                            : "NA"}
                                        </TableCell>
                                      ) : (
                                        ""
                                      )}

                                      {localData?.isSubDepartmentEnable ? (
                                        <TableCell align="center">
                                          {" "}
                                          {data.subDepartmentName !== null
                                            ? data.subDepartmentName
                                            : "NA"}
                                        </TableCell>
                                      ) : (
                                        ""
                                      )}
                                      <TableCell align="center">
                                        {data.clientName !== null
                                          ? data.clientName
                                          : "NA"}
                                      </TableCell>
                                      <TableCell align="center">
                                        {data.hrmsExpenseTypeDto &&
                                          data.hrmsExpenseTypeDto
                                            .hrmsExpenseName}
                                      </TableCell>
                                      <TableCell>
                                        {data
                                          ? data.appliedAmount !== null
                                            ? data.appliedAmount.toFixed(2)
                                            : "0.00"
                                          : "0.00"}
                                      </TableCell>
                                      <TableCell align="center">
                                        <Box
                                          sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            gap: "10px",
                                          }}
                                        >
                                          <span>
                                            {/* {data
                                              ? data.amount !== null
                                                ? data.amount.toFixed(2)
                                                : "NA"
                                              : "NA"} */}
                                            {data.approvedAmount
                                              ? data.approvedAmount
                                              : "0.00"}
                                          </span>
                                          <UseModal
                                            button={"icon"}
                                            title={"Gallery"}
                                            width={"50%"}
                                          >
                                            <ImageList
                                              sx={{ width: 500, height: 450 }}
                                              cols={3}
                                              rowHeight={164}
                                            >
                                              {data.userFileExpenseDto &&
                                              data.userFileExpenseDto !== null
                                                ? data.userFileExpenseDto
                                                    .length > 0 &&
                                                  data.userFileExpenseDto.map(
                                                    (item, i) => {
                                                      return (
                                                        <ImageListItem key={i}>
                                                          <img
                                                            src={`${item.fileUrl}?w=164&h=164&fit=crop&auto=format`}
                                                            srcSet={`${item.fileUrl}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
                                                            alt={"Images"}
                                                            loading="lazy"
                                                          />
                                                        </ImageListItem>
                                                      );
                                                    },
                                                  )
                                                : "NA"}
                                            </ImageList>
                                          </UseModal>
                                        </Box>
                                      </TableCell>
                                      <TableCell align="center">
                                        {data.appliedAmount &&
                                        data.approvedAmount
                                          ? Math.max(
                                              data.appliedAmount -
                                                data.approvedAmount,
                                              0,
                                            ).toFixed(2)
                                          : "0.00"}
                                      </TableCell>
                                      {localData?.isOdMeterReadingRequiredOnOd ? (
                                        <TableCell>
                                          {data
                                            ? data.odometerTotalDistance !==
                                              null
                                              ? data.odometerTotalDistance.toFixed(
                                                  2,
                                                )
                                              : "0.00"
                                            : "0.00"}
                                        </TableCell>
                                      ) : (
                                        ""
                                      )}
                                      {localData?.isOdMeterReadingRequiredOnOd ? (
                                        <TableCell>
                                          {data
                                            ? data.odometerExpenseAmount !==
                                              null
                                              ? data.odometerExpenseAmount.toFixed(
                                                  2,
                                                )
                                              : "0.00"
                                            : "0.00"}
                                        </TableCell>
                                      ) : (
                                        ""
                                      )}
                                      <TableCell align="center">
                                        {data.remarks !== null &&
                                        data.remarks !== ""
                                          ? data.remarks
                                          : "NA"}
                                      </TableCell>
                                    </TableRow>
                                  </TableBody>
                                </Table>
                              </TableContainer>

                              {/* Expense Approve Trail */}
                              {data.trailData && (
                                <React.Fragment>
                                  <Typography variant="h6" sx={{ mt: 5 }}>
                                    Approval Trail
                                  </Typography>
                                  <TableContainer component={Paper}>
                                    <Table size="small" id="FlowUpTable">
                                      <TableHead>
                                        <TableRow
                                          style={{
                                            backgroundColor: "rgb(32 80 130)",
                                            color: "#fff",
                                          }}
                                        >
                                          <TableCell
                                            style={{ color: "#fff" }}
                                            align="center"
                                          >
                                            S.No
                                          </TableCell>
                                          <TableCell
                                            style={{ color: "#fff" }}
                                            align="center"
                                          >
                                            Action Taken On
                                          </TableCell>
                                          <TableCell
                                            style={{ color: "#fff" }}
                                            align="center"
                                          >
                                            Approver Name
                                          </TableCell>
                                          <TableCell
                                            style={{ color: "#fff" }}
                                            align="center"
                                          >
                                            Applied Amt(₹)
                                          </TableCell>
                                          <TableCell
                                            style={{ color: "#fff" }}
                                            align="center"
                                          >
                                            Approved Amt(₹)
                                          </TableCell>
                                          <TableCell
                                            style={{ color: "#fff" }}
                                            align="center"
                                          >
                                            Deviated Amt(₹)
                                          </TableCell>
                                          {localData?.isOdMeterReadingRequiredOnOd ? (
                                            <TableCell
                                              style={{ color: "#fff" }}
                                              align="center"
                                            >
                                              Odometer Distance(Kms)
                                            </TableCell>
                                          ) : (
                                            ""
                                          )}
                                          {localData?.isOdMeterReadingRequiredOnOd ? (
                                            <TableCell
                                              style={{ color: "#fff" }}
                                              align="center"
                                            >
                                              Odometer Amt(₹)
                                            </TableCell>
                                          ) : (
                                            ""
                                          )}

                                          <TableCell
                                            style={{ color: "#fff" }}
                                            align="center"
                                          >
                                            Remark
                                          </TableCell>
                                          <TableCell
                                            style={{ color: "#fff" }}
                                            align="center"
                                          >
                                            Status
                                          </TableCell>
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        {data.trailData?.map((trail, ind) => {
                                          return (
                                            <TableRow
                                              key={trail.id + "trail"}
                                              sx={{
                                                ".MuiTableCell-root": {
                                                  textAlign: "center",
                                                },
                                              }}
                                            >
                                              <TableCell>{ind + 1}</TableCell>
                                              <TableCell>
                                                {moment(trail.createdAt).format(
                                                  "DD-MM-YYYY",
                                                )}
                                              </TableCell>
                                              <TableCell>{`${trail.approver.name}(${trail.approver.empCode})`}</TableCell>
                                              <TableCell>
                                                {data.appliedAmount
                                                  ? data.appliedAmount.toFixed(
                                                      2,
                                                    )
                                                  : 0}
                                              </TableCell>
                                              <TableCell>
                                                {trail.approvedAmount
                                                  ? trail.approvedAmount.toFixed(
                                                      2,
                                                    )
                                                  : 0}
                                              </TableCell>
                                              <TableCell>
                                                {data.appliedAmount &&
                                                trail.approvedAmount
                                                  ? Math.max(
                                                      data.appliedAmount -
                                                        trail.approvedAmount,
                                                      0,
                                                    ).toFixed(2)
                                                  : "0.00"}
                                              </TableCell>
                                              {localData?.isOdMeterReadingRequiredOnOd ? (
                                                <TableCell>
                                                  {data.odometerTotalDistance
                                                    ? data.odometerTotalDistance.toFixed(
                                                        2,
                                                      )
                                                    : 0}
                                                </TableCell>
                                              ) : (
                                                ""
                                              )}
                                              {localData?.isOdMeterReadingRequiredOnOd ? (
                                                <TableCell>
                                                  {data.odometerExpenseAmount
                                                    ? data.odometerExpenseAmount.toFixed(
                                                        2,
                                                      )
                                                    : 0}
                                                </TableCell>
                                              ) : (
                                                ""
                                              )}
                                              <TableCell>
                                                {trail.remarks || "NA"}
                                              </TableCell>
                                              <TableCell
                                                sx={{
                                                  color:
                                                    trail.actionTakenStatus ===
                                                    "APPROVED"
                                                      ? "green"
                                                      : trail.actionTakenStatus ===
                                                          "REJECTED"
                                                        ? "red"
                                                        : "#d9ac32",
                                                }}
                                              >
                                                {trail.actionTakenStatus}
                                              </TableCell>
                                            </TableRow>
                                          );
                                        })}
                                      </TableBody>
                                    </Table>
                                  </TableContainer>
                                </React.Fragment>
                              )}
                            </UseModal>
                            <span>
                              {data.approvedAmount
                                ? data.approvedAmount
                                : "0.00"}
                            </span>
                          </Box>
                        </TableCell>
                        <TableCell align="right">
                          {data.appliedAmount && data.approvedAmount
                            ? Math.max(
                                data.appliedAmount - data.approvedAmount,
                                0,
                              ).toFixed(2)
                            : "0.00"}
                        </TableCell>
                        {localData?.isOdMeterReadingRequiredOnOd ? (
                          <TableCell align="center">
                            {data.odometerTotalDistance?.toFixed(2) || "NA"}
                          </TableCell>
                        ) : (
                          ""
                        )}
                        {localData?.isOdMeterReadingRequiredOnOd ? (
                          <TableCell align="right">
                            {data.odometerExpenseAmount?.toFixed(2) || "NA"}
                          </TableCell>
                        ) : (
                          ""
                        )}
                        <TableCell align="center">
                          {data.remarks !== null && data.remarks !== ""
                            ? data.remarks
                            : "NA"}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                {/* <TableRow>
                  <TableCell align="center">1</TableCell>
                  <TableCell align="center">1</TableCell>
                  <TableCell align="center">1</TableCell>
                  <TableCell align="center">1</TableCell>
                  <TableCell align="center">1</TableCell>
                  <TableCell align="center">1</TableCell>
                </TableRow> */}
              </TableBody>
            </Table>
          </TableContainer>
          <Box sx={{ pb: 1.5 }}>
            <TablePagination
              component="div"
              count={totalElements}
              page={pageNo}
              rowsPerPageOptions={[10, 25, 50, 100, 500]}
              onPageChange={handleChangePage}
              rowsPerPage={pageSize}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Box>

          <Grid item xs={12}>
            <Box className="mein_label">
              {isMultiApproverEnabled && (
                <Box className="border">
                  <IconButton size="small">
                    <CircleIcon sx={{ color: "#F7AA5E" }} />
                  </IconButton>
                  <Typography variant="p">Partially Approved</Typography>
                </Box>
              )}
              <Box className="border">
                <IconButton size="small" color="success">
                  <CircleIcon />
                </IconButton>
                <Typography variant="p">Approved</Typography>
              </Box>
              <Box className="border">
                <IconButton size="small" sx={{ color: "#E57373" }}>
                  <CircleIcon />
                </IconButton>
                <Typography variant="p">Rejected</Typography>
              </Box>
              {/* <Box className="border">
                    <IconButton size="small" sx={{ color: "#E3C009" }}>
                    <CircleIcon />
                    </IconButton>
                    <Typography variant="p">
                      Pendding
                    </Typography>
                  </Box> */}
              <Box className="border">
                <IconButton size="small" sx={{ color: "#ADD8E6" }}>
                  <CircleIcon />
                </IconButton>
                <Typography variant="p">Amount Deviation</Typography>
              </Box>
            </Box>
          </Grid>

          {/* <UseModal
            button={"icon"}
            title={"Expense - (100)"}
            width={"50%"}
          ></UseModal> */}
        </Grid>
      </Grid>
    </main>
  );
};

export default ExpenseList;
